import { MenuItem } from '../../../lib/phinxapp/profiles/types';
import { customersMenu } from './Customers';
import { dashboardMenu } from './Dashboard/dashboardMenu';
import { usersMenu } from './Users';
import { transactionsMenu } from './Transactions';
import { settingMenu } from './Setting';

export const routes: MenuItem[] = [dashboardMenu, usersMenu, customersMenu, transactionsMenu, settingMenu];
